import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './translate/en_translate.json';
import translationPT from './translate/br_translate.json';


i18n
  .use(initReactI18next) 
  .init({
    resources: {
      en: {
        translation: translationEN, 
      },
      pt: {
        translation: translationPT, 
      },
    },
    lng: 'en', 
    fallbackLng: 'en', 
    interpolation: {
      escapeValue: false, 
    },
  });

export default i18n;
